import { Input, Stack, VisuallyHidden } from '@chakra-ui/react'
import isEmpty from 'lodash/isEmpty'
import type { FC } from 'react'

import { Field } from '@app/components/ui/field'
import { PasswordInput } from '@app/components/ui/password-input'
import type { Credential } from '@graphql/types'

interface Props {
  serviceName: string
  credential?: Pick<Credential, 'host' | 'port' | 'database' | 'username'>
}

const OdbcAuth: FC<Props> = ({ serviceName, credential }) => (
  <Stack>
    <Field label="Host" required>
      <Input
        autoComplete="off"
        data-1p-ignore
        defaultValue={credential?.host}
        name="host"
        placeholder={`${serviceName} host URL/IP`}
      />
    </Field>
    <Field label="Database port" required>
      <Input
        autoComplete="off"
        data-1p-ignore
        defaultValue={credential?.port}
        name="port"
        placeholder={`${serviceName} port number`}
      />
    </Field>
    <Field label="Database name" required>
      <Input
        autoComplete="off"
        data-1p-ignore
        defaultValue={credential?.database}
        name="database"
        placeholder="Database name"
      />
    </Field>
    <Field label="Username" required>
      <Input
        autoComplete="off"
        data-1p-ignore
        defaultValue={credential?.username}
        name="username"
        placeholder="Service user name"
      />
    </Field>
    <Field
      label="Password"
      required={isEmpty(credential)}
      helperText={
        !isEmpty(credential) ? 'Leave blank to keep the current password or fill in to set a new password' : null
      }
    >
      <PasswordInput name="password" placeholder="Service user password" autoComplete="off" data-1p-ignore />
    </Field>
    {!!Object.keys(credential || {}).length && (
      <VisuallyHidden asChild>
        <Input defaultValue="password" name="secretFields" />
      </VisuallyHidden>
    )}
  </Stack>
)

export default OdbcAuth
